import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.myprofile');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-myprofile',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.myprofile/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageMyprofileComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public view: string = null;
    public isAdmin: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        this.isAdmin = ['admin', 'super_admin'].includes(this.service.auth.session?.membership);
        await this.changeView("info");
        await this.service.loading.hide();
    }

    public async changeView(view) {
        this.view = view;
        await this.service.render();
    }

    public activeClass(view) {
        if (this.view == view)
            return 'cursor-pointer group flex gap-x-3 rounded-md bg-zinc-50 py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-blue-600';
        return 'cursor-pointer group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-zinc-700 hover:bg-zinc-50 hover:text-blue-600';
    }
}

export default PageMyprofileComponent;